import axios from 'axios';
import cms from './cms';

export interface IDeleteUserRequest {
  email: string;
}

export interface IDeleteUserResponse {
  success: boolean;
  message: string;
}

export async function deleteUserByEmail(email: string): Promise<IDeleteUserResponse> {
  try {
    const response = await cms.post<IDeleteUserResponse>('/v2/users/delete-by-email', {
      email
    });
    return response.data;
  } catch (error: unknown) {
    if (
      axios.isAxiosError(error)
    ) {
      throw new Error(error.response?.data.error.message);
    }
    
    throw new Error('Error inesperado. Por favor, inténtalo de nuevo.');
  }
}
